/**
 * @file index
 */

import AppComponent from './containers/app';
import App from '@/lib/App';
import '@baidu/cosmic/dist/mobile/index.css';
import '@baidu/cosmic/dist/mobile/tokens.css';
import '@baidu/iconfont/font-cos-wise.css';
import '../styles/color.less';

// eslint-disable-next-line @babel/new-cap
App(AppComponent, '#app');